import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({

  imgStyle: {
    marginBottom: '12px',
    height: '200px',
    // backgroundImage: productImage ? productImage.src : `url(${productDescPreview})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
  },
  productText: {
    fontWeight: 'bold',
    fontSize: 24,
  },
  addCartButton: {
    display: 'inline-block',
    borderRadius: '4px',
    padding: '5px 10px',
    backgroundColor: 'black',
    color: 'white',
    marginBottom: '8px',
  },
}));

const ProductDescriptionGraphic = ({
  companyName = '',
  productName = '',
}) => {
  const classes = useStyles();

  return (
    <div>
      {/* <div>
        <div className={classes.imgStyle} />
      </div> */}
      <div className={classes.productText}>
        <span>
          {productName}
          {' '}
          from
          {' '}
          {companyName}
        </span>
      </div>
      {/* <p>$ 39.99</p> */}
      {/* <div
        className={classes.addCartButton}
      >
        + Add to cart
      </div> */}
    </div>
  );
};

export default ProductDescriptionGraphic;
